export default function SubtestsResultsView() {
  return (
    <div className='pt-5'>
      <h2 className='justify-content-center'>
        <p className='lead text-center'>Subtests</p>
      </h2>
    </div>
  );
}
